<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="gotoWelcomePage">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>Abonnement verlengt</v-toolbar-title>
		</v-toolbar>

		<v-content class="uf-form">
			<v-container class="item-group" mb-4>
				<h2>Gefeliciteerd</h2>
				<h3>Het abonnement voor je E-finder is met success verlengt.</h3><br/>
				<p>Nu kan je naar de main pagina terug gaan en naar je account aanmelden.</p>

				<v-btn block dark depressed large color="primary" @click="gotoWelcomePage" class="mt-4">
					Ga naar de main pagina
				</v-btn>

			</v-container>
		</v-content>
	</div>
</template>

<script>
	export default {
		methods: {
			gotoWelcomePage() {
				this.$router.push({name: 'welcome'});
			},
		}
	}
</script>
